<tui-loader [showLoader]="isLoading()" [overlay]="isLoading()">
  <app-night-theme />
  <tui-root [attr.tuiTheme]="night() ? 'dark' : null">
    <router-outlet />
  </tui-root>
</tui-loader>
